import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import {
  getData,
  postData,
} from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import {
  Modal,
  Button,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
} from "reactstrap";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../redux-toolkit/store";
import {
  setVarifiedExpenses,
  addVarifiedExpense,
} from "../../../redux-toolkit/reducers/VarifiedExpensesReducer";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";

interface ExpenseMaster {
  ExpenseName: string;
  IsMandatory?: boolean;
  AttachmentRequired?: boolean | number;
  Commentreq?: number | boolean;
  Israteapplied?: number | boolean;
  isRateApplied?: number | boolean;
  Rate?: number | string;
  Mode?: string;
}

interface ExpenseItem {
  ExpId?: number;
  ExpMasterId?: number;
  ExpListId: number;
  ExpenseMaster: ExpenseMaster;
  ExpIlAmount: string | number;
  ExpFinalAmount: string | number;
  ExpNote?: string;
  ExpRemark?: string;
  ExpAuditRemark?: string;
  Israteapplied?: number | boolean;
  isRateApplied?: number | boolean;
  Rate?: number | string;
  Mode?: string;
  ExpRateQty?: string | number;
  ExpenseListDetailss?: any[];
  IsReadonly?: boolean;
}

interface ExpenseDetails {
  data: ExpenseItem[];
  expenses?: {
    ExpId?: number;
    ExpenseDate?: string;
    ExpenseNote?: string;
  };
  DayActivities?: Record<string, Record<string, string>>;
}

const ExpenseOverview: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { expId: initialExpId, doVerify: initialDoVerify, expenseStatus: initialExpenseStatus, isOwnUser, manager, expenseList: initialExpenseList, currentIndex: initialIndex } = location.state || {};

  const [expenseList, setExpenseList] = useState<any[]>(initialExpenseList || []);
  const [currentIndex, setCurrentIndex] = useState<number>(typeof initialIndex === "number" ? initialIndex : 0);

  const currentItem = expenseList[currentIndex];
  const activeExpId = currentItem?.expenses?.ExpId || initialExpId;
  const activeExpenseStatus = currentItem?.expenses?.ExpenseStatus ?? initialExpenseStatus;
  const activeDoVerify = currentItem?.expenses?.DoVerify ?? initialDoVerify;
  const activeExpenseDate = currentItem?.expenses?.ExpenseDate || currentItem?.date;

  // Rule: Own user can only edit Requested/Initial amount (no Final amount edit).
  // Non-own user (manager/reviewer) can only edit Final/Approved amount (no Initial amount edit).
  const isOwn = isOwnUser !== undefined ? Boolean(isOwnUser) : (!manager && !activeDoVerify);

  const [expenseDetails, setExpenseDetails] = useState<ExpenseDetails | null>(null);
  const [showLoader, setShowLoader] = useState(true);

  // Navigation handlers for switching expenses
  const goToPrevious = () => {
    let prevIndex = currentIndex - 1;
    while (prevIndex >= 0 && !expenseList[prevIndex]?.expenses) {
      prevIndex--;
    }
    if (prevIndex >= 0) {
      setCurrentIndex(prevIndex);
    }
  };

  const goToNext = () => {
    let nextIndex = currentIndex + 1;
    while (nextIndex < expenseList.length && !expenseList[nextIndex]?.expenses) {
      nextIndex++;
    }
    if (nextIndex < expenseList.length) {
      setCurrentIndex(nextIndex);
    }
  };

  // Add Expense Heads Modal state
  const [addLineItemModal, setAddLineItemModal] = useState(false);
  const [moreExpArray, setMoreExpArray] = useState<{ label: string; value: number }[]>([]);
  const [selectedHeads, setSelectedHeads] = useState<number[]>([]);

  // Initial / Requested Amount Modal state
  const [openAmountModal, setOpenAmountModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [addAmountNote, setAddAmountNote] = useState("");
  const [rateQty, setRateQty] = useState("");
  const [km, setKm] = useState("");
  const [isRateApplied, setIsRateApplied] = useState(false);
  const [perticularLineItemData, setPerticularLineItemData] = useState<ExpenseItem | null>(null);

  // Approved Amount Modal state
  const [openApprovedAmountModal, setOpenApprovedAmountModal] = useState(false);
  const [approvedAmount, setApprovedAmount] = useState("");
  const [note, setNote] = useState("");
  const [approvedKm, setApprovedKm] = useState("");
  const [approvedRateQty, setApprovedRateQty] = useState("");
  const [isApprovedRateApplied, setIsApprovedRateApplied] = useState(false);

  const [refresh, setRefresh] = useState(false);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedExpListId, setSelectedExpListId] = useState<number | null>(null);

  // Details Modal and Attachment state
  const [expenseListDetails, setExpenseListDetails] = useState<any[]>([]);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [currentExpListId, setCurrentExpListId] = useState<number | null>(null);

  // Add Detail Modal State
  const [openAddAttachmentModal, setOpenAddAttachmentModal] = useState(false);
  const [detailAmount, setDetailAmount] = useState("");
  const [detailDescription, setDetailDescription] = useState("");
  const [detailMediaId, setDetailMediaId] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploadingFile, setUploadingFile] = useState(false);

  // Edit Detail Modal State
  const [openEditDetailModal, setOpenEditDetailModal] = useState(false);
  const [editDetailId, setEditDetailId] = useState<number | null>(null);
  const [editDetailAmount, setEditDetailAmount] = useState("");
  const [editDetailDescription, setEditDetailDescription] = useState("");
  const [editDetailMediaId, setEditDetailMediaId] = useState("");
  const [editDetailFile, setEditDetailFile] = useState<File | null>(null);
  const [updatingDetail, setUpdatingDetail] = useState(false);

  // Image Preview Modal State
  const [openImageModal, setOpenImageModal] = useState(false);
  const [previewMediaId, setPreviewMediaId] = useState("");

  const dispatch = useDispatch();
  const variedExpenses = useSelector(
    (state: RootState) => state.varifiedExpenses[activeExpId] || []
  );

  const triggerRefresh = () => setRefresh((prev) => !prev);

  // Helper to construct image URL
  const getMediaUrl = (mediaId: any) => {
    if (!mediaId) return "";
    let baseUrl = localStorage.getItem("serverUrl") || "";
    if (!baseUrl.endsWith("/")) {
      baseUrl += "/";
    }
    return `${baseUrl}media?id=${mediaId}`;
  };

  useEffect(() => {
    let loaderTimeout: NodeJS.Timeout;
    const fetchExpenseDetails = async () => {
      try {
        setShowLoader(true);
        const url = `${localStorage.getItem("serverUrl")}${API.getExpensesMaster}`;
        const params = { ExpId: activeExpId };
        const [response] = await Promise.all([
          postData(url, true, params),
          new Promise((resolve) => (loaderTimeout = setTimeout(resolve, 1000)))
        ]);
        const { status, data } = response as any;
        if (status === 200) {
          setExpenseDetails(data?.data);
        } else {
          console.error("Failed to fetch expense details.");
        }
      } catch (error) {
        console.error("Error fetching expense details:", error);
      } finally {
        setShowLoader(false);
      }
    };
    if (activeExpId) {
      fetchExpenseDetails();
    }
    return () => {
      if (loaderTimeout) clearTimeout(loaderTimeout);
    };
  }, [activeExpId, refresh, currentIndex]);

  const headData = [
    {
      id: "expenseName",
      head: "Expense Name",
      key: "ExpenseMaster.ExpenseName",
      sortKey: "ExpenseMaster.ExpenseName",
    },
    {
      id: "initialAmount",
      head: "Initial Amount",
      key: "ExpIlAmount",
      sortKey: "ExpIlAmount",
    },
    {
      id: "finalAmount",
      head: "Final Amount",
      key: "ExpFinalAmount",
      sortKey: "ExpFinalAmount",
    },
    { id: "note", head: "Note", key: "ExpNote", sortKey: "ExpNote" },
    { id: "remark", head: "Remark", key: "ExpRemark", sortKey: "ExpRemark" },
    {
      id: "auditRemark",
      head: "Audit Remark",
      key: "ExpAuditRemark",
      sortKey: "ExpAuditRemark",
    },
    { id: "actions", head: "Actions", key: "actions" },
  ];

  const getVarifiedExps = () => {
    dispatch(setVarifiedExpenses({ expId: activeExpId, expenses: variedExpenses }));
  };

  useEffect(() => {
    getVarifiedExps();
  }, []);

  const markVarified = (item: ExpenseItem) => {
    dispatch(
      addVarifiedExpense({ expId: activeExpId, expenseName: item.ExpenseMaster.ExpenseName })
    );
    triggerRefresh();
    navigate(-1);
  };

  // Open modal to add new expense heads
  const openNewHeadsList = async () => {
    const targetExpId = activeExpId || expenseDetails?.expenses?.ExpId;
    if (!targetExpId) {
      toast.warning("Expense ID not available");
      return;
    }
    try {
      const url = `${localStorage.getItem("serverUrl")}${API.addMoreExp}/${targetExpId}`;
      const { status, data } = await getData(url, true);
      if (status === 200 && data?.data && data.data.length > 0) {
        setMoreExpArray(data.data);
        setSelectedHeads([]);
        setAddLineItemModal(true);
      } else {
        toast.warning(data?.message || "No more expenses to add");
      }
    } catch (e: any) {
      toast.error(e?.message || "Error fetching expense heads");
    }
  };

  // Submit adding selected expense heads
  const addMoreExpense = async () => {
    const targetExpId = activeExpId || expenseDetails?.expenses?.ExpId;
    if (selectedHeads.length < 1) {
      toast.warning("Please select the expense you want to add");
      return;
    }
    try {
      let hasError = false;
      await Promise.allSettled(
        selectedHeads.map(async (i) => {
          const url = `${localStorage.getItem("serverUrl")}${API.addMoreExpPost}/${targetExpId}?ExpMasterId%5B%5D=${i}`;
          const { status, data } = await postData(url, true, {});
          if (status !== 200) {
            hasError = true;
            toast.warning(data?.message || `Failed to add head ID ${i}`);
          }
        })
      );
      if (!hasError) {
        toast.success("Expense head(s) added successfully");
      }
      setAddLineItemModal(false);
      triggerRefresh();
    } catch (err: any) {
      toast.error("Error adding expense head");
    }
  };

  // Open Requested Amount Modal
  const openAddAmountModal = (item: ExpenseItem) => {
    const isAttachmentRequired = item?.ExpenseMaster?.AttachmentRequired;
    if (isAttachmentRequired && (!item?.ExpenseListDetailss || item?.ExpenseListDetailss?.length < 1)) {
      toast.error(
        "Attachment is mandatory for this expense. Please go to details and add attachments."
      );
      return;
    }
    setPerticularLineItemData(item);
    const rateApplied = Boolean(
      item?.ExpenseMaster?.Israteapplied == 1 ||
      item?.ExpenseMaster?.isRateApplied == 1 ||
      item?.ExpenseMaster?.isRateApplied === true ||
      item?.Israteapplied == 1 ||
      item?.isRateApplied == 1
    );
    setIsRateApplied(rateApplied);
    setAddAmountNote(item.ExpRemark || "");

    if (!rateApplied) {
      setAmount(item.ExpIlAmount?.toString() || "");
    } else {
      const defaultRate = item?.Rate ?? item?.ExpenseMaster?.Rate ?? "";
      setRateQty(defaultRate?.toString() || "0");
      setKm(item?.ExpRateQty?.toString() || "");
    }
    setOpenAmountModal(true);
  };

  // Save Requested Amount
  const handleSaveAmount = async () => {
    if (!perticularLineItemData) return;
    if (perticularLineItemData?.ExpenseMaster?.Commentreq == 1 && !addAmountNote.trim()) {
      toast.warning("Note is required for this expense");
      return;
    }
    try {
      let params: any = {};
      const targetExpId = perticularLineItemData.ExpId || activeExpId || expenseDetails?.expenses?.ExpId;

      if (!isRateApplied) {
        params = {
          ExpLineId: perticularLineItemData.ExpMasterId,
          ExpQty: amount,
          ILQty: amount,
          exp_remark: addAmountNote,
        };
      } else {
        const numericRate = Number(rateQty || perticularLineItemData?.Rate || perticularLineItemData?.ExpenseMaster?.Rate || 0);
        const numericKm = Number(km || 0);
        const computedValue = numericRate * numericKm;
        params = {
          ExpLineId: perticularLineItemData.ExpMasterId,
          ExpQty: computedValue,
          ILQty: computedValue,
          remarks: addAmountNote,
          ExpRateQty: km || "0",
          ExpRateMode: perticularLineItemData?.Mode ?? perticularLineItemData?.ExpenseMaster?.Mode ?? "",
        };
      }

      const url = `${localStorage.getItem("serverUrl")}${API.expensesSubmit}/${targetExpId}`;
      const { status, data } = await postData(url, true, params);

      if (status === 200 || status === 100) {
        toast.success(data?.message || "Amount saved successfully");
        setOpenAmountModal(false);
        setAddAmountNote("");
        triggerRefresh();
      } else {
        toast.warning(data?.message || "Failed to save amount");
      }
    } catch (err) {
      console.error("Error saving amount:", err);
      toast.error("An error occurred while saving.");
    }
  };

  // Open Approved Amount Modal
  const openAddApprovedAmountModal = (item: ExpenseItem) => {
    setPerticularLineItemData(item);
    const rateApplied = Boolean(
      item?.ExpenseMaster?.Israteapplied == 1 ||
      item?.ExpenseMaster?.isRateApplied == 1 ||
      item?.ExpenseMaster?.isRateApplied === true ||
      item?.Israteapplied == 1 ||
      item?.isRateApplied == 1
    );
    setIsApprovedRateApplied(rateApplied);
    setApprovedAmount(item.ExpFinalAmount?.toString() || "");
    setNote(item.ExpRemark || "");
    setApprovedKm(item.ExpRateQty?.toString() || "");
    const defaultRate = item?.Rate ?? item?.ExpenseMaster?.Rate ?? "";
    setApprovedRateQty(defaultRate?.toString() || "0");
    setOpenApprovedAmountModal(true);
  };

  // Submit Approved Amount Edit
  const editAndApproveLineItemAmount = async (lineItemData: any) => {
    if (!lineItemData) return;
    try {
      const url = `${localStorage.getItem("serverUrl")}${API.editApprovalExpenses}/${lineItemData.ExpListId}`;
      let params: any = {
        action: "auth",
        exp_remark: note,
        ExpNote: note,
      };

      if (isApprovedRateApplied) {
        const kmToSend = approvedKm === "" || approvedKm == null ? "0" : approvedKm;
        params.exp_rate_qty = kmToSend;
        const rateNumeric = Number(lineItemData?.Rate || lineItemData?.ExpenseMaster?.Rate || approvedRateQty || 0);
        const computedAmt = rateNumeric * Number(kmToSend || 0);
        params.ExpAprAmount = String(computedAmt);
      } else {
        params.ExpAprAmount = approvedAmount;
      }

      const { status, data } = await postData(url, true, params);

      if (status === 200) {
        toast.success(data.message || "Approved amount updated");
        setOpenApprovedAmountModal(false);
        triggerRefresh();
      } else {
        toast.warning(data.message || "Failed to update approved amount");
        setOpenApprovedAmountModal(false);
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error("An error occurred while approving the amount.");
    }
  };

  const toggleDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen);

  const handleDeleteClick = (expListId: number) => {
    setSelectedExpListId(expListId);
    toggleDeleteModal();
  };

  const confirmDelete = async () => {
    if (!selectedExpListId) return;

    try {
      const url = `${localStorage.getItem("serverUrl")}${API.deleteExpenseList}`;
      const params = { exp_list_id: selectedExpListId };
      const { status, data } = await getData(url, true, params);

      if (status === 200) {
        toast.success("Expense deleted successfully!");
        triggerRefresh();
      } else {
        toast.error("Failed to delete expense.");
      }
    } catch (error) {
      console.error("Error deleting expense:", error);
      toast.error("An error occurred while deleting the expense.");
    } finally {
      toggleDeleteModal();
    }
  };

  const makeNoteBold = (txt: string) => {
    if (!txt) return "-";
    let txt1 = txt.split("|");
    return [
      txt1[0],
      txt1[1] ? <strong key="1"> {txt1[1]} </strong> : null,
      txt1[2] ? <strong key="2"> {txt1[2]?.split(",")[0]} </strong> : null,
      txt1[2] ? txt1[2]?.split(",")[1] : null,
      txt1[2] ? txt1[2]?.split(",")[2] : null,
      txt1[3] ? <strong key="3"> {txt1[3]} </strong> : null,
      txt1[4] ? <strong key="4"> {txt1[4]} </strong> : null,
    ];
  };

  const renderRow = (item: ExpenseItem, index: number) => {
    const statusNum = Number(activeExpenseStatus);
    const isStatusEditable = statusNum === 1 || statusNum === 2 || statusNum === 4;

    return (
      <tr key={index}>
        <td style={{ paddingLeft: "10px" }}>
          {item.ExpenseMaster?.ExpenseName}
        </td>
        <td style={{ paddingLeft: "10px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>{item.ExpIlAmount}</span>
            {/* Initial Amount Edit: Visible ONLY for own user when status is Created (1), Submitted (2), or Rejected (4) and not readonly */}
            {isOwn && isStatusEditable && !item?.IsReadonly && (
              <button
                style={{
                  marginLeft: "10px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={() => openAddAmountModal(item)}
                title="Edit Initial / Requested Amount"
              >
                <i
                  className="fa fa-edit"
                  style={{ color: "#1c65d3", fontSize: "16px" }}
                ></i>
              </button>
            )}
          </div>
        </td>
        <td style={{ paddingLeft: "10px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>{item.ExpFinalAmount}</span>
            {/* Final Amount Edit: Visible ONLY if NOT own user (manager/approver) and not readonly */}
            {!isOwn && !item?.IsReadonly && (
              <button
                style={{
                  marginLeft: "10px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={() => openAddApprovedAmountModal(item)}
                title="Edit Approved Amount"
              >
                <i
                  className="fa fa-edit"
                  style={{ color: "#28a745", fontSize: "16px" }}
                ></i>
              </button>
            )}
          </div>
        </td>
        <td style={{ paddingLeft: "10px" }}>
          {item.ExpNote
            ? item.ExpNote.includes("|")
              ? makeNoteBold(item.ExpNote)
              : item.ExpNote
            : "-"}
        </td>
        <td style={{ paddingLeft: "10px" }}>{item.ExpRemark || "-"}</td>
        <td style={{ paddingLeft: "10px" }}>{item.ExpAuditRemark || "-"}</td>
        <td style={{ paddingLeft: "10px" }}>
          <button
            style={{
              cursor: "pointer",
              padding: "5px 10px",
              backgroundColor: "#1c65d3",
              color: "white",
              border: "none",
              borderRadius: "5px",
            }}
            onClick={() => {
              setCurrentExpListId(item.ExpListId);
              fetchExpenseListDetails(item.ExpListId);
              setOpenDetailsModal(true);
            }}
          >
            Details
          </button>
        </td>
        <td style={{ cursor: "pointer", paddingLeft: "10px" }}>
          {isOwn && isStatusEditable && !item?.IsReadonly && (
            <span
              onClick={() => {
                handleDeleteClick(item.ExpListId);
              }}
            >
              <i
                className="fa fa-trash"
                style={{ color: "red", fontSize: "16px" }}
              ></i>
            </span>
          )}
        </td>
      </tr>
    );
  };

  const [activityData, setActivityData] = useState<string[][]>([]);
  const [activityLabelName, setActivitylabelName] = useState<string[]>([]);

  useEffect(() => {
    try {
      const obj = expenseDetails?.DayActivities;
      if (obj) {
        const dayActivityData = Object.keys(obj)?.reduce<string[][]>(
          (arr, item) => {
            const values = Object.values(obj[item]) as string[];
            arr.push([item, ...values]);
            return arr;
          },
          []
        );
        setActivityData(dayActivityData);

        const patchName = Object.keys(obj)[0];
        const labelName = Object.keys(obj[patchName]);
        labelName.unshift("Patch");
        setActivitylabelName(labelName);
      }
    } catch (error) {
      console.error("Error processing activity data:", error);
    }
  }, [expenseDetails]);

  // Fetch expense list details for Details modal
  const fetchExpenseListDetails = async (listId: number) => {
    try {
      const url = `${localStorage.getItem("serverUrl")}${API.getExpenseListDetails}`;
      const params = { exp_list_id: listId };
      const { status, data } = await getData(url, true, params);

      if (status === 200) {
        setExpenseListDetails(data.data || []);
      } else {
        setExpenseListDetails([]);
        console.error("Failed to fetch expense list details.");
      }
    } catch (error) {
      setExpenseListDetails([]);
      console.error("Error fetching expense list details:", error);
    }
  };

  // Click handler for media attachments: queries downloadFile API to detect PDF vs Image and opens accordingly (like in POD/Expense flow)
  const handleMediaClick = async (mediaId: string) => {
    if (!mediaId) return;
    try {
      let serverBaseUrl = localStorage.getItem("serverUrl") || "";
      if (!serverBaseUrl.endsWith("/")) {
        serverBaseUrl += "/";
      }
      const downloadApiUrl = `${serverBaseUrl}${API.downloadFile}`;
      const { data } = await getData(downloadApiUrl, true, { mediaid: mediaId });
      const dataObj = data?.data || data || {};
      const mediatype = String(dataObj.mediatype || dataObj.file_type || dataObj.mime_type || dataObj.type || "").toLowerCase();
      const pdfurl = String(dataObj.pdfurl || dataObj.url || dataObj.DownLoadUrl || dataObj.download_url || "");

      const isPdf =
        mediatype.includes("pdf") ||
        pdfurl.toLowerCase().includes(".pdf") ||
        pdfurl.toLowerCase().includes("pdf");

      if (isPdf) {
        const finalPdfUrl = pdfurl || `${serverBaseUrl}media?id=${mediaId}`;
        window.open(finalPdfUrl, "_blank");
      } else {
        setPreviewMediaId(mediaId);
        setOpenImageModal(true);
      }
    } catch (err) {
      console.error("Error detecting media type:", err);
      setPreviewMediaId(mediaId);
      setOpenImageModal(true);
    }
  };

  // Upload attachment file or image. Uses Base64 upload for images (API.uploadMediaBase64) and FormData for PDFs/documents (API.uploadFile)
  const uploadAttachmentFile = async (file: File): Promise<string> => {
    try {
      setUploadingFile(true);
      const isImage = file.type.startsWith("image/") || Boolean(file.name.match(/\.(jpg|jpeg|png|gif|webp|bmp)$/i));

      if (isImage) {
        // Image: convert to Base64 and call API.uploadMediaBase64
        const base64Data = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const res = (reader.result as string) || "";
            const sanitized = res.replace(/^data:[^;]+;base64,/, "").replace(/\s/g, "");
            resolve(sanitized);
          };
          reader.onerror = (err) => reject(err);
        });

        const body = {
          folder_id: 1,
          media: [base64Data],
        };
        const url = `${localStorage.getItem("serverUrl")}${API.uploadMediaBase64}`;
        const { status, data } = await postData(url, true, body);

        console.log("Upload Base64 Response:", data);

        if (status === 200 || data?.statusCode === 200) {
          const d1 = Array.isArray(data?.data) ? data.data[0] : (data?.data || data?.id);
          if (d1) {
            toast.success("Image uploaded successfully via Base64");
            return String(d1);
          }
        }
        toast.error(data?.message || "Failed to upload Base64 image");
        return "";
      } else {
        // PDF / Document: upload via multipart FormData (API.uploadFile)
        const formData = new FormData();
        formData.append("mediafile", file);

        const token =
          localStorage.getItem("appToken") ||
          localStorage.getItem("apptoken") ||
          localStorage.getItem("token") ||
          "";
        let serverUrl = localStorage.getItem("serverUrl") || "";
        if (!serverUrl.endsWith("/")) {
          serverUrl += "/";
        }

        const response = await fetch(`${serverUrl}${API.uploadFile}`, {
          method: "POST",
          headers: {
            ...(token ? { apptoken: token } : {}),
          },
          body: formData,
        });

        const resData = await response.json();
        console.log("Upload File Response:", resData);

        let mediaId = "";
        if (
          resData?.status === 200 ||
          resData?.statusCode === 200 ||
          resData?.statusCode == "200"
        ) {
          if (typeof resData?.data === "object" && resData?.data?.data) {
            mediaId = String(resData.data.data);
          } else if (typeof resData?.data === "object" && resData?.data?.id) {
            mediaId = String(resData.data.id);
          } else if (typeof resData?.data === "string" || typeof resData?.data === "number") {
            mediaId = String(resData.data);
          } else if (resData?.id) {
            mediaId = String(resData.id);
          }
        }

        if (mediaId) {
          toast.success("Document uploaded successfully");
          return mediaId;
        } else {
          toast.error(resData?.message || "Failed to upload document");
          return "";
        }
      }
    } catch (e: any) {
      console.error("Upload error:", e);
      toast.error(e?.message || "Upload failed");
      return "";
    } finally {
      setUploadingFile(false);
    }
  };

  // Handle file select in Add Attachment Modal
  const handleFileSelectAdd = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setSelectedFile(file);
      const uploadedId = await uploadAttachmentFile(file);
      if (uploadedId) {
        setDetailMediaId(uploadedId);
      }
    }
  };

  // Handle Save Attachment (Create Expense Line Item Detail)
  const handleCreateExpenseDetail = async () => {
    if (!currentExpListId) return;
    if (!detailAmount || !detailDescription.trim()) {
      toast.warning("Amount and Description are required");
      return;
    }

    try {
      let mediaId = detailMediaId;
      if (!mediaId && selectedFile) {
        mediaId = await uploadAttachmentFile(selectedFile);
      }

      const params = {
        expense_list_id: currentExpListId,
        image: mediaId || "",
        description: detailDescription,
        amount: detailAmount,
      };

      console.log("Submitting Create Expense Detail Params:", params);

      const url = `${localStorage.getItem("serverUrl")}${API.createExpenseListDetailss}`;
      const { status, data } = await postData(url, true, params);

      if (status === 200) {
        toast.success(data?.message || "Attachment detail added successfully");
        setOpenAddAttachmentModal(false);
        setDetailAmount("");
        setDetailDescription("");
        setDetailMediaId("");
        setSelectedFile(null);
        fetchExpenseListDetails(currentExpListId);
        triggerRefresh();
      } else {
        toast.warning(data?.message || "Failed to add attachment detail");
      }
    } catch (err) {
      console.error("Error creating expense detail:", err);
      toast.error("An error occurred while adding detail.");
    }
  };

  // Open Edit Detail Modal
  const openEditDetail = (detailItem: any) => {
    const id = detailItem.ExpListDetailId || detailItem.ExpListDetailsId || detailItem.id || detailItem.ExpDetId || detailItem.ExpDetailId;
    const mediaImage = detailItem.Image || detailItem.image || detailItem.ImageMediaId || detailItem.MediaId || "";
    setEditDetailId(id);
    setEditDetailAmount(detailItem.Amount?.toString() || "");
    setEditDetailDescription(detailItem.Description || detailItem.description || "");
    setEditDetailMediaId(mediaImage);
    setEditDetailFile(null);
    setOpenEditDetailModal(true);
  };

  // Handle file select in Edit Detail Modal
  const handleFileSelectEdit = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setEditDetailFile(file);
      const uploadedId = await uploadAttachmentFile(file);
      if (uploadedId) {
        setEditDetailMediaId(uploadedId);
      }
    }
  };

  // Submit Edit Detail
  const handleUpdateExpenseDetail = async () => {
    if (!editDetailId) return;
    if (!editDetailAmount || !editDetailDescription.trim()) {
      toast.warning("Amount and Description are required");
      return;
    }

    try {
      setUpdatingDetail(true);
      let mediaId = editDetailMediaId;
      if (editDetailFile && !mediaId) {
        const uploadedId = await uploadAttachmentFile(editDetailFile);
        if (uploadedId) {
          mediaId = uploadedId;
        }
      }

      const params = {
        expense_list_detail_id: editDetailId,
        image: mediaId || "",
        description: editDetailDescription,
        amount: editDetailAmount,
      };

      console.log("Submitting Update Expense Detail Params:", params);

      const url = `${localStorage.getItem("serverUrl")}${API.updateExpenseListDetails}`;
      const { status, data } = await postData(url, true, params);

      if (status === 200) {
        toast.success(data?.message || "Expense detail updated successfully");
        setOpenEditDetailModal(false);
        if (currentExpListId) {
          fetchExpenseListDetails(currentExpListId);
        }
        triggerRefresh();
      } else {
        toast.warning(data?.message || "Failed to update expense detail");
      }
    } catch (err) {
      console.error("Error updating expense detail:", err);
      toast.error("An error occurred while updating detail.");
    } finally {
      setUpdatingDetail(false);
    }
  };

  // Delete a specific detail item in the details table
  const handleDeleteDetailItem = async (detailId: number) => {
    if (!detailId) return;
    try {
      const url = `${localStorage.getItem("serverUrl")}${API.deleteExpenseListDetails}`;
      const params = { list_detail_id: detailId };
      const { status, data } = await getData(url, true, params);

      if (status === 200) {
        toast.success(data?.message || "Detail deleted successfully!");
        if (currentExpListId) {
          fetchExpenseListDetails(currentExpListId);
        }
        triggerRefresh();
      } else {
        toast.error(data?.message || "Failed to delete detail.");
      }
    } catch (error) {
      console.error("Error deleting detail:", error);
      toast.error("An error occurred while deleting detail.");
    }
  };

  if (showLoader) {
    return (
      <div className="text-center py-3">
        <div>
          <Image
            className="b-r-10 img-80"
            src={dynamicImage("dashboard/loader.gif")}
            alt="Loading..."
          />
        </div>
      </div>
    );
  }

  if (!expenseDetails || !expenseDetails.data || expenseDetails.data.length === 0) {
    return <p className="p-3">No data found.</p>;
  }

  return (
    <div className="page-body p-3">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
        <CardHeaderSpan
          headingClassName="p-2"
          back={true}
          heading={"Expense Overview"}
          span={"ReportListTitle"}
        />
        {/* + Add Expense button available for own user */}
        {isOwn && (
          <Button
            color="primary"
            style={{ backgroundColor: "#1c65d3", borderColor: "#1c65d3", fontWeight: 500 }}
            onClick={openNewHeadsList}
          >
            <i className="fa fa-plus me-2"></i>Add Expense
          </Button>
        )}
      </div>

      {/* Date Navigation Bar matching mobile APK behavior */}
      {expenseList && expenseList.length > 0 && (
        <div
          className="d-flex align-items-center justify-content-center p-3 mb-3 bg-white border rounded shadow-sm"
          style={{ gap: "20px" }}
        >
          <Button
            color="primary"
            size="sm"
            disabled={currentIndex <= 0}
            onClick={goToPrevious}
            style={{
              backgroundColor: currentIndex <= 0 ? "#ccc" : "#1c65d3",
              borderColor: currentIndex <= 0 ? "#ccc" : "#1c65d3",
              padding: "5px 15px",
            }}
          >
            <i className="fa fa-chevron-left me-1"></i> Previous
          </Button>

          <h5 className="m-0 fw-bold text-dark">
            {activeExpenseDate
              ? moment(activeExpenseDate).format("dddd, DD MMM YYYY")
              : "Expense Details"}
          </h5>

          <Button
            color="primary"
            size="sm"
            disabled={currentIndex >= expenseList.length - 1}
            onClick={goToNext}
            style={{
              backgroundColor: currentIndex >= expenseList.length - 1 ? "#ccc" : "#1c65d3",
              borderColor: currentIndex >= expenseList.length - 1 ? "#ccc" : "#1c65d3",
              padding: "5px 15px",
            }}
          >
            Next <i className="fa fa-chevron-right ms-1"></i>
          </Button>
        </div>
      )}

      {expenseDetails ? (
        <CommonTableNew
          tableClass="table caption"
          strip={false}
          caption=""
          size="sm"
          hover
          headData={headData}
          data={expenseDetails.data}
          renderRow={renderRow}
        />
      ) : (
        <div className="text-center py-3">
          <div>
            <Image
              className="b-r-10 img-80"
              src={dynamicImage("dashboard/loader.gif")}
              alt="Loading..."
            />
          </div>
        </div>
      )}

      {/* Add Expense Heads Modal */}
      <Modal isOpen={addLineItemModal} toggle={() => setAddLineItemModal(false)}>
        <ModalHeader toggle={() => setAddLineItemModal(false)}>
          Add Expense Heads
        </ModalHeader>
        <ModalBody>
          {moreExpArray && moreExpArray.length > 0 ? (
            moreExpArray.map((item, index) => (
              <FormGroup check key={index} className="mb-2">
                <Input
                  type="checkbox"
                  id={`exp-head-${item.value}`}
                  checked={selectedHeads.includes(item.value)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedHeads((prev) => [...prev, item.value]);
                    } else {
                      setSelectedHeads((prev) => prev.filter((id) => id !== item.value));
                    }
                  }}
                />
                <Label check htmlFor={`exp-head-${item.value}`} style={{ cursor: "pointer", marginLeft: "8px" }}>
                  {item.label}
                </Label>
              </FormGroup>
            ))
          ) : (
            <p>No more expenses available to add.</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={addMoreExpense}>
            Add
          </Button>
          <Button color="secondary" onClick={() => setAddLineItemModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* Requested Amount Edit Modal */}
      <Modal isOpen={openAmountModal} toggle={() => setOpenAmountModal(false)}>
        <ModalHeader toggle={() => setOpenAmountModal(false)}>
          Requested Amount
        </ModalHeader>
        <ModalBody style={{ padding: "20px" }}>
          {isRateApplied ? (
            <>
              <FormGroup>
                <Label>Rate</Label>
                <Input type="text" value={rateQty} disabled />
              </FormGroup>
              <FormGroup className="mt-2">
                <Label>Kilometers (KM)</Label>
                <Input
                  type="number"
                  placeholder="Enter Kilometers"
                  value={km}
                  onChange={(e) => setKm(e.target.value)}
                />
              </FormGroup>
              <FormGroup className="mt-2">
                <Label>Calculated Amount</Label>
                <Input
                  type="text"
                  value={Number(rateQty || 0) * Number(km || 0)}
                  disabled
                />
              </FormGroup>
            </>
          ) : (
            <FormGroup>
              <Label>Amount</Label>
              <Input
                type="number"
                placeholder="Enter Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value.replace(/[^0-9.]/g, ""))}
              />
            </FormGroup>
          )}
          <FormGroup className="mt-2">
            <Label>Note / Remark</Label>
            <Input
              type="textarea"
              placeholder="Enter Note"
              value={addAmountNote}
              onChange={(e) => setAddAmountNote(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSaveAmount}>
            Save
          </Button>
          <Button color="secondary" onClick={() => setOpenAmountModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* Approved Amount Edit Modal */}
      <Modal
        isOpen={openApprovedAmountModal}
        toggle={() => setOpenApprovedAmountModal(false)}
      >
        <ModalHeader toggle={() => setOpenApprovedAmountModal(false)}>
          Approved Amount
        </ModalHeader>
        <ModalBody style={{ padding: "20px" }}>
          {isApprovedRateApplied ? (
            <>
              <FormGroup>
                <Label>Rate</Label>
                <Input type="text" value={approvedRateQty} disabled />
              </FormGroup>
              <FormGroup className="mt-2">
                <Label>Approved Kilometers (KM)</Label>
                <Input
                  type="number"
                  placeholder="Enter Approved Kilometers"
                  value={approvedKm}
                  onChange={(e) => setApprovedKm(e.target.value)}
                />
              </FormGroup>
              <FormGroup className="mt-2">
                <Label>Calculated Approved Amount</Label>
                <Input
                  type="text"
                  value={Number(approvedRateQty || 0) * Number(approvedKm || 0)}
                  disabled
                />
              </FormGroup>
            </>
          ) : (
            <FormGroup>
              <Label>Approved Amount</Label>
              <Input
                type="number"
                placeholder="Enter Approved Amount"
                value={approvedAmount}
                onChange={(e) =>
                  setApprovedAmount(e.target.value.replace(/[^0-9.]/g, ""))
                }
              />
            </FormGroup>
          )}
          <FormGroup className="mt-2">
            <Label>Note / Remark</Label>
            <Input
              type="textarea"
              placeholder="Enter Note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() =>
              editAndApproveLineItemAmount(perticularLineItemData)
            }
          >
            Submit
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenApprovedAmountModal(false)}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* Confirmation Delete Modal */}
      <Modal isOpen={isDeleteModalOpen} toggle={toggleDeleteModal}>
        <ModalHeader toggle={toggleDeleteModal}>Confirm Deletion</ModalHeader>
        <ModalBody>Are you sure you want to delete this expense?</ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>
            Delete
          </Button>
          <Button color="secondary" onClick={toggleDeleteModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* Details Modal */}
      <Modal
        isOpen={openDetailsModal}
        toggle={() => setOpenDetailsModal(false)}
        size="lg"
      >
        <ModalHeader toggle={() => setOpenDetailsModal(false)}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <span>Expense Details</span>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "20px" }}>
          {/* Add Attachment / Add Detail button for own user inside Details modal */}
          {isOwn && (
            <div style={{ marginBottom: "15px", textAlign: "right" }}>
              <Button
                color="primary"
                style={{ backgroundColor: "#1c65d3", borderColor: "#1c65d3" }}
                onClick={() => {
                  setDetailAmount("");
                  setDetailDescription("");
                  setDetailMediaId("");
                  setSelectedFile(null);
                  setOpenAddAttachmentModal(true);
                }}
              >
                <i className="fa fa-plus me-2"></i>Add Attachment
              </Button>
            </div>
          )}

          {expenseListDetails && expenseListDetails.length > 0 ? (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Image
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Remark
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Rupees
                  </th>
                  {isOwn && (
                    <th style={{ border: "1px solid #ddd", padding: "8px", width: "100px", textAlign: "center" }}>
                      Action
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {expenseListDetails.map((detail: any, index: number) => {
                  const detailId = detail.ExpListDetailId || detail.ExpListDetailsId || detail.id || detail.ExpDetId || detail.ExpDetailId;
                  const imageMediaId = detail.Image || detail.image || detail.ImageMediaId || detail.MediaId || "";
                  return (
                    <tr key={index}>
                      <td
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        {imageMediaId ? (
                          <div
                            style={{ cursor: "pointer", display: "inline-block" }}
                            onClick={() => handleMediaClick(imageMediaId)}
                            title="Click to view attachment (Image / PDF)"
                          >
                            <img
                              src={getMediaUrl(imageMediaId)}
                              alt="Expense Attachment"
                              style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "5px", border: "1px solid #ccc" }}
                              onError={(e: any) => {
                                e.target.style.display = "none";
                                const parent = e.target.parentElement;
                                if (parent) {
                                  let docIcon = parent.querySelector(".pdf-fallback-icon");
                                  if (docIcon) docIcon.style.display = "block";
                                }
                              }}
                            />
                            <div className="pdf-fallback-icon" style={{ display: "none", textAlign: "center", padding: "8px" }}>
                              <i className="fa fa-file-pdf-o text-danger" style={{ fontSize: "32px" }}></i>
                              <div style={{ fontSize: "10px", marginTop: "4px", color: "#666" }}>PDF Document</div>
                            </div>
                          </div>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        {detail.Description || detail.description || "-"}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                        <p className="m-0">{detail.Amount}</p>
                      </td>
                      {isOwn && (
                        <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                          <span
                            style={{ cursor: "pointer", marginRight: "12px" }}
                            onClick={() => openEditDetail(detail)}
                            title="Edit Detail"
                          >
                            <i className="fa fa-edit" style={{ color: "#1c65d3", fontSize: "16px" }}></i>
                          </span>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDeleteDetailItem(detailId)}
                            title="Delete Detail"
                          >
                            <i className="fa fa-trash" style={{ color: "red", fontSize: "16px" }}></i>
                          </span>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>No details or attachments found.</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setOpenDetailsModal(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Add Attachment Modal (Inside Details) */}
      <Modal
        isOpen={openAddAttachmentModal}
        toggle={() => setOpenAddAttachmentModal(false)}
      >
        <ModalHeader toggle={() => setOpenAddAttachmentModal(false)}>
          Add Attachment
        </ModalHeader>
        <ModalBody style={{ padding: "20px" }}>
          <FormGroup>
            <Label>Amount *</Label>
            <Input
              type="number"
              placeholder="Enter Amount"
              value={detailAmount}
              onChange={(e) => setDetailAmount(e.target.value)}
            />
          </FormGroup>
          <FormGroup className="mt-3">
            <Label>Description / Remark *</Label>
            <Input
              type="textarea"
              placeholder="Enter Description"
              value={detailDescription}
              onChange={(e) => setDetailDescription(e.target.value)}
            />
          </FormGroup>
          <FormGroup className="mt-3">
            <Label>Attachment / Image</Label>
            <Input
              type="file"
              accept="image/*,.pdf"
              onChange={handleFileSelectAdd}
            />
            {uploadingFile && <p className="text-info mt-1 mb-0" style={{ fontSize: "12px" }}>Uploading attachment...</p>}
            {detailMediaId && (
              <div className="mt-2">
                <Label className="d-block" style={{ fontSize: "12px", color: "green" }}>✓ Attachment Uploaded (Media ID: {detailMediaId})</Label>
                <div style={{ cursor: "pointer", display: "inline-block" }} onClick={() => handleMediaClick(detailMediaId)}>
                  <img
                    src={getMediaUrl(detailMediaId)}
                    alt="Attachment Preview"
                    style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "5px", border: "1px solid #28a745" }}
                    onError={(e: any) => {
                      e.target.style.display = "none";
                      const parent = e.target.parentElement;
                      if (parent) {
                        let docIcon = parent.querySelector(".pdf-fallback-icon");
                        if (docIcon) docIcon.style.display = "block";
                      }
                    }}
                  />
                  <div className="pdf-fallback-icon" style={{ display: "none", textAlign: "center", padding: "8px" }}>
                    <i className="fa fa-file-pdf-o text-danger" style={{ fontSize: "32px" }}></i>
                    <div style={{ fontSize: "10px", marginTop: "4px", color: "#666" }}>PDF Document</div>
                  </div>
                </div>
              </div>
            )}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleCreateExpenseDetail}
            disabled={uploadingFile}
          >
            {uploadingFile ? "Uploading..." : "Save"}
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenAddAttachmentModal(false)}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* Edit Detail Modal */}
      <Modal
        isOpen={openEditDetailModal}
        toggle={() => setOpenEditDetailModal(false)}
      >
        <ModalHeader toggle={() => setOpenEditDetailModal(false)}>
          Edit Expense Detail
        </ModalHeader>
        <ModalBody style={{ padding: "20px" }}>
          <FormGroup>
            <Label>Amount *</Label>
            <Input
              type="number"
              placeholder="Enter Amount"
              value={editDetailAmount}
              onChange={(e) => setEditDetailAmount(e.target.value)}
            />
          </FormGroup>
          <FormGroup className="mt-3">
            <Label>Description / Remark *</Label>
            <Input
              type="textarea"
              placeholder="Enter Description"
              value={editDetailDescription}
              onChange={(e) => setEditDetailDescription(e.target.value)}
            />
          </FormGroup>
          {editDetailMediaId && (
            <FormGroup className="mt-3">
              <Label className="d-block">Current Attachment</Label>
              <div style={{ cursor: "pointer", display: "inline-block" }} onClick={() => handleMediaClick(editDetailMediaId)}>
                <img
                  src={getMediaUrl(editDetailMediaId)}
                  alt="Current attachment"
                  style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "5px", border: "1px solid #ccc" }}
                  onError={(e: any) => {
                    e.target.style.display = "none";
                    const parent = e.target.parentElement;
                    if (parent) {
                      let docIcon = parent.querySelector(".pdf-fallback-icon");
                      if (docIcon) docIcon.style.display = "block";
                    }
                  }}
                />
                <div className="pdf-fallback-icon" style={{ display: "none", textAlign: "center", padding: "8px" }}>
                  <i className="fa fa-file-pdf-o text-danger" style={{ fontSize: "36px" }}></i>
                  <div style={{ fontSize: "10px", marginTop: "4px", color: "#666" }}>PDF Document</div>
                </div>
              </div>
            </FormGroup>
          )}
          <FormGroup className="mt-3">
            <Label>Change Attachment / Image</Label>
            <Input
              type="file"
              accept="image/*,.pdf"
              onChange={handleFileSelectEdit}
            />
            {uploadingFile && <p className="text-info mt-1 mb-0" style={{ fontSize: "12px" }}>Uploading new attachment...</p>}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleUpdateExpenseDetail}
            disabled={updatingDetail || uploadingFile}
          >
            {updatingDetail || uploadingFile ? "Saving..." : "Update"}
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenEditDetailModal(false)}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* Full Size Image Preview Lightbox Modal */}
      <Modal
        isOpen={openImageModal}
        toggle={() => setOpenImageModal(false)}
        size="lg"
        centered
      >
        <ModalHeader toggle={() => setOpenImageModal(false)}>
          Image Preview
        </ModalHeader>
        <ModalBody className="text-center p-3">
          {previewMediaId && (
            <img
              src={getMediaUrl(previewMediaId)}
              alt="Full Preview"
              style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: "8px" }}
            />
          )}
        </ModalBody>
        <ModalFooter style={{ justifyContent: "space-between" }}>
          {previewMediaId && (
            <a
              href={getMediaUrl(previewMediaId)}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-primary btn-sm"
            >
              <i className="fa fa-download me-1"></i> Open / Download Full Image
            </a>
          )}
          <Button color="secondary" onClick={() => setOpenImageModal(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Render Activity Data Table */}
      {activityData.length > 0 && activityLabelName.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <h3>Activity Data</h3>
          <CommonTableNew
            tableClass="table caption"
            strip={false}
            caption=""
            size="sm"
            hover
            headData={activityLabelName.map((label, index) => ({
              id: `col-${index}`,
              head: label,
              key: label,
            }))}
            data={activityData.map((row) => {
              const rowData: Record<string, string | number> = {};
              activityLabelName.forEach((label, index) => {
                rowData[label] = row[index] || "-";
              });
              return rowData;
            })}
            renderRow={(row, index) => (
              <tr key={index}>
                {activityLabelName.map((label, colIndex) => (
                  <td style={{ paddingLeft: "10px" }} key={colIndex}>
                    {row[label]}
                  </td>
                ))}
              </tr>
            )}
          />
        </div>
      )}
    </div>
  );
};

export default ExpenseOverview;
